<template>
  <div class="h-tabs">
    <div class="h-tabs__header">
      <div class="h-tabs__tab">
        <slot name="tabs"></slot>
      </div>
      <slot name="right-header"></slot>
    </div>
    <slot name="contents"></slot>
  </div>
</template>
<script>
import { computed } from 'vue'

export default {
  provide() {
    return {
      handleSelectTab: this.handleSelectTab,
      activeTab: computed(() => this.activeTab)
    }
  },
  model: {
    prop: 'activeTab',
    event: 'update:activeTab'
  },
  props: {
    activeTab: {
      type: String,
      required: true
    }
  },
  emits: ['update:activeTab'],
  methods: {
    handleSelectTab(name) {
      this.$emit('update:activeTab', name)
    }
  }
}
</script>
<style lang="scss" scoped>
.h-tabs {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--gl-spacing-04);
  }
  &__tab {
    list-style: none;
    display: flex;
    padding: 0;
  }
}
</style>
